import { render } from "./top.vue?vue&type=template&id=4ed7f374&scoped=true"
import script from "./top.vue?vue&type=script&lang=js"
export * from "./top.vue?vue&type=script&lang=js"

import "./top.vue?vue&type=style&index=0&id=4ed7f374&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/CIS-new-front.rule.vip.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ed7f374"]])

export default __exports__